<template>
	<form-perfil 
		is-edit
		:image-user="imageUser"/>
</template>
<script>
import formPerfil from '@/components/user/form-perfil';

export default {
	name: 'page-user-edit',
	components: {
		formPerfil,
	},
	props: {
		imageUser: [String],
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/user/page-user-edit.vue